<template>
    <AppHeaderDropdown right no-caret>
       <div id="listloader" v-if="loader">
                        <div class="listloader"></div>
                        <br/>
                       <span class="loading" style="color:#fff;">Loading...</span>
                      </div>
      <template slot="header">
       <span style="font-size: 18px;" data-toggle="tooltip" title="Pending Vehicles Count">
        <i class="fa fa-bell-o" aria-hidden="true" style="color: #197e97;"></i>
        <sup style="color: red;font-weight: bold;font-size: 15px;">{{ AllcountShow }}</sup>
      </span>
      </template>
      <template slot="dropdown" > 
        <div style="width: 500px;
        position: absolute;
        background: rgb(255, 255, 255);
        padding: 7px 25px;
        top: 0px;
        border: 1px solid rgba(114, 110, 110, 0.61);
        box-shadow: rgba(0, 0, 0, 0.2) 2px 4px 3px 2px, rgba(0, 0, 0, 0.19) 0px 6px 10px 0px;
        left: -185px;
        font-family: sans-serif;
        overflow: scroll;
        height: 400px;" class="tabslisting">
        <div class="tabset">
            <!-- Tab 1 -->
            <input type="radio" name="tabset" id="tab1" aria-controls="marzen" checked>
            <label for="tab1"><i class="fa fa-user-o" aria-hidden="true"></i>
                <br>
                All Action
            </label>
            <!-- Tab 2 -->
            <input type="radio" name="tabset" id="tab2" aria-controls="rauchbier">
            <label for="tab2"><i class="fa fa-file-text-o" aria-hidden="true"></i>
                <br>
                Alerts
            </label>
            <!-- Tab 3 -->
            <input type="radio" name="tabset" id="tab3" aria-controls="dunkles">
            <label for="tab3"><i class="fa fa-calendar" aria-hidden="true"></i>
                <br>
                Attendence 
            </label>
            
            <div class="tab-panels">
              <section id="marzen" class="tab-panel">
                <div>
                  <ul v-for="(i, index) in item" :key="index">
                    <li style="cursor: pointer;">
                      <b>{{ index + 1 }}.</b>&nbsp;&nbsp;
                      <!-- <span v-html="highlightText(i.alert_msg)" @click="redirect_toadhoc(i.alert_msg,i.id)"></span> -->
                      
                      <span v-html="highlightText(i.alert_msg)" v-if="i.alert_msg.includes('Please check Transhipment request raised by')" @click="redirect_totranshipmentapproval(i.alert_msg,i.id)"></span>

                      <span v-else v-html="highlightText(i.alert_msg)" @click="redirect_toadhoc(i.alert_msg,i.id)"></span>

                    </li>
                    &nbsp;
                  </ul>
                    <ul v-if="item.length>0">
                      <li class="text-center">
                        <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace; color: #106baff5; font-weight: 600;">
                            See All Notifications
                        </span>
                      </li>
                    </ul>
                    <div v-if="item.length==0" class="text-center">
                      <h5>No Record Found</h5>
                    </div>
                    <!-- <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace; color: #106baff5; font-weight: 600; position: fixed; top: 390px;
                    right: 150px;">
                        See All Notifications
                    </span> -->
                </div>
                
            </section>
              <section id="rauchbier" class="tab-panel">
                <!-- <h2>6B. Rauchbier</h2> -->
                
              </section>
              <section id="dunkles" class="tab-panel">
                <!-- <h2>6C. Dunkles Bock</h2> -->
                
              </section>
            </div>
            
        </div>
        </div>

      </template>
    </AppHeaderDropdown>
  
       
</template>
  
<script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import Vue from 'vue'
  import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
  export default {
    name: 'DefaultHeaderDropdownAutomicvehicle',
    components: {
      AppHeaderDropdown
    },
    data: () => {
      return { 
        item:[],
        AllcountShow : 0,
        loader:true
      }
  
    },
    activated() {
   let setHeader=JSON.parse(localStorage.getItem('userData'));
      Vue.http.headers.common['x-access-token']  = setHeader.token;
      this.getAllAlertsData();
  },  

    // created() {
    //   let setHeader=JSON.parse(localStorage.getItem('userData'));
    //   Vue.http.headers.common['x-access-token']  = setHeader.token;
    //   this.getAllAlertsData();
    // },
     mounted() {
    this.resetState();
    this.getAllAlertsData(); // Fetch data on component mount
    window.addEventListener("flagUpdated", this.updateFlag);

  },
  watch: {
    $route(to, from) {
      this.resetState();
      this.getAllAlertsData(); // Fetch data when route changes
    },
     AllcountShow(newVal) {
      console.log("AllcountShow watcher:", newVal);
    },
  },
  beforeDestroy() {
    window.removeEventListener("flagUpdated", this.updateFlag);
  },
    methods: {
        updateFlag(event) {
          this.flag = event.detail;
          console.log("=====================",this.flag)
          if (this.flag==1) {
            this.getAllAlertsData(); // Fetch data when route changes
          }
        },
        highlightText(text) {
          // Replace vehicle number pattern with bold formatting and cursor pointer style
          return text.replace(/([A-Za-z]{2}\d{2}[A-Za-z]{2}\d{4})/g, '<span style="cursor: pointer; font-weight: bold;">$1</span>');
        },

        redirect_toadhoc(msg,value) {
          this.loader=true;
          console.log(msg, value,'msgmsg')
          const phrase = "Incident reported";
          if (msg.includes(phrase)) {
            console.log('in incident page')
            if (this.$route.name == 'incident_master') {
            // This is the 'adhocVehicle' route
            this.$fire({
              text:"You Are In Already Incident Master Page. Please check Incident",
              type: "warning",
              timer: 30000,
              });
            this.loader=false;
              // return false;  
            } else {
              this.loader=false;
              this.$router.push("/incident_master")
            }

          } 
          else {
            console.log(' not in incident page')
            console.log("this.$router",this.$route.name)
            if (this.$route.name == 'adhocVehicle') {
              // This is the 'adhocVehicle' route
              this.$fire({
                text:"You Are In Already Adhoc Vehicle Details Page. Please Add Vehicle Details",
                type: "warning",
                timer: 30000,
                });
              this.loader=false;
              // return false;  
            } else {
              this.loader=false;
              this.$router.push("/adhocVehicle")
            }
          }
          
          const Obj = {
            id: value
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getSeenNotificationAlerts`,Obj)
          .then((result)=>{
            console.log(result)
            this.loader=false;
            if (result.body.returnmsg=="Successful") {
              // this.$fire({
              //   text: result.body.returnvalue,
              //   type: "success",
              //   timer: 30000,
              // });
              this.getAllAlertsData();
              this.getAllAlertsData();
            } else {
              this.$fire({
                text: `Data Not Found`,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((error)=>{
            console.log(error)
          })
        },

        resetState() {
      this.item = [];
      this.AllcountShow = 0;
    },
    getAllAlertsData() {
      this.loader = true;
      this.item = [];
      this.AllcountShow = 0;

      const userdata = localStorage.getItem("userData");
      const userInfo = JSON.parse(userdata);

      const Obj = {
        hub_id: userInfo.hub_id == null ? null : `${userInfo.hub_id}`,
        email_id: `${userInfo.sysemailid}`,
        // userid: `${userInfo.sysusermasterid}`,
      };

      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getAllAlerts`, Obj)
        .then((result) => {
          this.loader = false;
          console.log(result);
    const { returnmsg, returnvalue } = result.body;

  if (returnvalue === "Failed to authenticate token.") {
      alert("Session expired. Please log in again.");
      localStorage.clear(); // or remove only the token if stored
      sessionStorage.clear();
      window.location.reload(); // reload page (or redirect to login)
      return;
    }

          if (result.body.returnmsg === "Successful") {
            const total_Rows = result.body.returnvalue.length;
            this.item = result.body.returnvalue;
            this.updateTotalRows(total_Rows); // Update CMS count
          } else {
            this.item = [];
            this.updateTotalRows(0); // Reset count on failure
          }
        })
        .catch((error) => {
          console.error("API call error:", error);
          this.loader = false; // Stop loader
        });
    },
    updateTotalRows(value) {
      console.log("Updating AllcountShow for CMS:", value);
      this.AllcountShow = value; // Update reactive variable
      this.$nextTick(() => {
        console.log("DOM updated with AllcountShow:", this.AllcountShow);
      });
    },

        redirect_totranshipmentapproval(){
          this.$router.push("/transhipment_admin_detail")
        }

    },
  }
</script>

<style scoped>
#listloader{
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.listloader{
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

  /*
 CSS for the main interaction
*/
.tabset > input[type="radio"] {
    position: absolute;
    left: -200vw;
  }
  
  .tabset .tab-panel {
    display: none;
  }
  
  .tabset > input:first-child:checked ~ .tab-panels > .tab-panel:first-child,
  .tabset > input:nth-child(3):checked ~ .tab-panels > .tab-panel:nth-child(2),
  .tabset > input:nth-child(5):checked ~ .tab-panels > .tab-panel:nth-child(3),
  .tabset > input:nth-child(7):checked ~ .tab-panels > .tab-panel:nth-child(4),
  .tabset > input:nth-child(9):checked ~ .tab-panels > .tab-panel:nth-child(5),
  .tabset > input:nth-child(11):checked ~ .tab-panels > .tab-panel:nth-child(6) {
    display: block;
  }
  
  /*
   Styling
  */
  body {
    font: 16px/1.5em "Overpass", "Open Sans", Helvetica, sans-serif;
    color: #333;
    font-weight: 300;
  }
  
  .tabset > label {
    position: relative;
    display: inline-block;
    padding: 15px 5px 25px;
    border: 1px solid transparent;
    border-bottom: 0;
    cursor: pointer;
    font-weight: 600;
    width: 140px;
    text-align: center;
    border-bottom: 1px solid #ccc;
  }
  
  .tabset > label::after {
    content: "";
    position: absolute;
    left: 68px;
    bottom: 10px;
    width: 11px;
    height: 11px;
    background: #8d8d8d;
    border-radius: 50% 50% 50% 50%;
  }
  .fa {
    font-size: 21px;
  }
  input:focus-visible + label {
    outline: 2px solid rgba(0,102,204,1);
    border-radius: 3px;
  }
  
  .tabset > label:hover::after,
  .tabset > input:focus + label::after,
  .tabset > input:checked + label::after {
    background: #0090cc;
  }
  
  .tabset > label:hover::after {
    background: #f09642;
  }

  .tabset > input:checked + label {
    border-color: #ccc;
    border-bottom: 1px solid #fff;
    margin-bottom: -1px;
  }
  
  .tab-panel {
    padding: 20px 0;
  }
  
  /*
   Demo purposes only
  */
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
  
  body {
    padding: 30px;
  }
  
  .tabset {
    max-width: 65em;
  }
</style>
  